/**
 * Canales de una pieza. El backend los guarda como array JSON (["facebook","instagram"]),
 * CSV legado ("IG, FB") o texto suelto, y según el orden de click del operador el mismo conjunto
 * llega distinto. Acá se normalizan (alias, minúsculas, sin duplicados, orden alfabético) para
 * mostrar etiquetas legibles y filtrar por canal individual. Mismo criterio que el backend
 * (portal/routes.js normalizarCanales).
 */
const ALIAS = {
  ig: "instagram", fb: "facebook", tt: "tiktok", yt: "youtube",
  x: "twitter", wsp: "whatsapp", mail: "email", publica: "via-publica", vp: "via-publica",
};

export function listaCanales(value) {
  if (!value) return [];
  let arr = [];
  if (Array.isArray(value)) arr = value;
  else if (typeof value === "string") {
    const s = value.trim();
    if (s.startsWith("[")) { try { arr = JSON.parse(s); } catch { arr = s.split(/[,;|]/); } }
    else arr = s.split(/[,;|]/);
  }
  return [...new Set(arr.map(c => String(c).replace(/[\[\]"]/g, "").trim().toLowerCase()).filter(Boolean).map(c => ALIAS[c] || c))].sort();
}

export const etiquetaCanal = (c) => {
  const t = String(c).replace(/[_-]+/g, " ").trim();
  return t.charAt(0).toUpperCase() + t.slice(1);
};

/** "Facebook · Instagram" */
export function formatCanal(value) {
  return listaCanales(value).map(etiquetaCanal).join(" · ");
}
